// Actions - Customization Reducer

// Active Menu
export const SET_MOBILE_DRAWER = "@customization/SET_MOBILE_DRAWER";
export const SET_DESKTOP_DRAWER = "@customization/SET_DESKTOP_DRAWER";

// UI
export const MENU_OPEN = "@customization/MENU_OPEN";
export const SET_FONT_FAMILY = "@customization/SET_FONT_FAMILY";
export const SET_BORDER_RADIUS = "@customization/SET_BORDER_RADIUS";
export const TICKET_GENERATOR_MODAL = "@customization/TICKET_GENERATOR_MODAL";

// export const SET_MENU = "@customization/SET_MENU"
